import React from 'react';

import {SortableElement, type SortableElementProps} from 'react-sortable-hoc';

import Item, {ItemManagerItemProps} from './ItemManagerItem';

export interface ItemManagerSortableItemProps
	extends ItemManagerItemProps,
		SortableElementProps {}

export default SortableElement<ItemManagerSortableItemProps>(
	(props: ItemManagerSortableItemProps) => <Item {...props} sortable={true} />,
);
